module.exports = __webpack_public_path__ + "img/logo-header-dark.9999cd9f.svg";